import { render, staticRenderFns } from "./resendEmailKplh.vue?vue&type=template&id=bdfd9c44&"
import script from "./resendEmailKplh.vue?vue&type=script&lang=js&"
export * from "./resendEmailKplh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports